import { render, staticRenderFns } from "./CBS.vue?vue&type=template&id=44a0ccef&"
import script from "./CBS.vue?vue&type=script&lang=js&"
export * from "./CBS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports